// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"33bfaf5c","601":"d1bfc9e8","701":"aabda8d5","884":"ddd0fe0d","904":"66776bdf"}[chunkId] + ".chunk.js";
};